<template>
  <div
    v-if="node && (!node.meta || !node.meta.overrides || node.meta.overrides.headercard !== false) && !node.locked && licenced(node) && authorized(node)"
    class="d-inline-flex">
    <v-card width="300" class=" mx-4 my-4 text-center" outlined>
      <router-link :to="{ name: node.name }" class="linkcleaner" v-slot="{ navigate }" custom>
        <v-container @click="navigate">
          <v-icon size="80" v-text="routeIcon(node)" />
          <h3 class="justify-center v--dark-text" v-text="routeDisplayName(node)">
          </h3>
        </v-container>
      </router-link>

      <v-divider v-if="hasVisableChildren" />
      <v-list v-if="hasVisableChildren" dense class="py-3">
        <v-list-item-group color="primary">
          <router-link v-for="item in node.children" :key="item.name" :to="{ name: item.name }" class="linkcleaner"
            v-slot="{ navigate }" custom>
            <v-list-item
              v-if="(!item.meta || !item.meta.overrides || item.meta.overrides.headercard !== false) && !item.locked && licenced(item) && featureEnabled(item) && authorized(item)"
              @click="navigate">
              <v-icon v-text="item.icon" />
              <v-list-item-content class="pl-4" v-text="routeDisplayName(item)">
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon v-text="'mdi-chevron-right'" />
              </v-list-item-icon>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["node"],

  mounted() { },

  methods: {
    isDynamic(node) {
      var returnValue = node.param ? true : false;
      return returnValue;
    },

    authorized(node) {
      return this.checkUserAuthorizationForNode(node);
    },
    licenced(node) {
      return this.checkIfLicencedByKey(node.meta.licenceEnabled);
    },
    featureEnabled(node) {
      return this.checkIfFeatureEnabledByKey(node.meta.featureEnabled);
    },
  },

  computed: {
    hasVisableChildren() {
      if (this.node.children && this.node.children[0] && this.licenced(this.node) && this.authorized(this.node)) {
        if (this.node.children.some((x) => !x.meta || !x.meta.overrides || x.meta.overrides.headercard !== false)) {
          return this.node.children;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
.linkcleaner {
  text-decoration: none;
  color: #121212;
  cursor: pointer;
}
</style>